import { createAction } from 'redux-actions';

export const setNewModalLoading = createAction(
  'STUDIO.SET_NEW_MODAL',
  loading => ({ loading })
);
